/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'firefox': {
    width: 27,
    height: 28,
    viewBox: '0 0 27 28',
    data: '<path pid="0" d="M14.109 28c-6.031 0-10.828-3.531-13.031-8.578C-1.391 13.813.578 4.828 4.969.86l-.172 4.391c.219-.281 1.891-.359 2.156 0 .906-1.734 3.828-3.031 6.172-3.078-.891.75-2.953 3.484-2.781 4.875 1.141.359 2.891.375 3.813.438.281.156.234 1.109-.328 1.891 0 0-.734 1.016-2.719 1.375l.234 2.953-2.172-1.047c-.703 1.781.984 3.359 2.734 3.063 1.937-.328 2.625-1.594 3.984-1.516 1.344.078 1.875.828 1.703 1.531 0 0-.219.844-1.672.703-1.234 1.953-2.875 2.812-5.531 2.578 4.031 3.344 9.469.313 10.844-2.422 1.375-2.719.172-6.766-1.203-7.906 1.625.703 2.75 1.422 3.344 3 .313-3.5-1.297-7.469-4.172-9.797C24.609 3.47 27.906 7.658 28 14.345s-5.922 13.656-13.891 13.656z"/>'
  }
})
